import { get, remove } from "../utils/helpers/storage";
import { getDateToday, getDateDiff } from "../utils/helpers/date";
import { TOKEN_KEY, USER_KEY, APPGUID } from "../utils/constants/SYSTEM";
import axios from "../utils/helpers/axios";

const auth = {
  loginAsync: async (email, password) => {
    try {
      const res = await axios().post(`/AdminUser/UserLogin`, {
        username: email,
        password,
        AppGUID: APPGUID,
      });

      const {
        userID,
        username,
        fullname,
        emailAddress,
        userRoles,
        jwtToken,
        errorMessage,
      } = res.data;

      if (errorMessage || !jwtToken) return null;

      const jwt = {
        jwtToken,
        loginDate: getDateToday(),
      };

      const user = {
        userID,
        username,
        fullname,
        emailAddress,
        userRoles,
      };

      return {
        jwt,
        user,
      };
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  logout: () => {
    remove(TOKEN_KEY);
    remove(USER_KEY);
  },
  getToken: () => {
    const jwt = get(TOKEN_KEY);
    return jwt ? jwt : null;
  },
  getUser: () => {
    try {
      return get(USER_KEY);
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  getAuth: () => {
    try {
      const token = get(TOKEN_KEY);
      const user = get(USER_KEY);

      if (!token || !user) return null;

      const { loginDate } = token;

      const today = getDateToday();
      const daysDiff = getDateDiff(loginDate, today);

      if (daysDiff >= 30) {
        // log out after 30 days
        this.logout();
        return null;
      }

      return {
        token,
        user,
      };
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  isTokenValidAsync: async () => {
    try {
      return await axios().post(`/AdminUser/ValidateToken`);
    } catch (err) {
      console.warn("Unauthorized access: invalid or expired token.");
      console.error(err);
      return false;
    }
  },
};

export default auth;
